import React, { Fragment } from "react";
import { motion } from "framer-motion";
import Header from "../../components/header/Header";
import Slider from "react-slick";
import Mcc from "../../components/mcc/Mcc";
import UrlagSport from "../../api/urlagsport";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
// import { useParams } from "react-router-dom";
// import esImg2 from "../../images/utilites/event-details2.jpg";

var urlagSportSlideSettings = {
  dots: false,
  infinite: true,
  speed: 1000,
  autoplay: true,
  arrows: false,
  adaptiveHeight: true,
  responsive: [],
};

const UrlagSportPage = ({ isDark, onToggleDark }) => {
  return (
    <Fragment>
      <motion.div
        intial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Header isDark={isDark} hclass={"header--styleFour"} />
        <main className="page_content about-page">
          <PageTitle
            pageTitle={"Урлаг Спорт"}
            pagesub={"урлаг-спорт"}
            tolink={"#urlagsport"}
          />
          <section className="stories pt-60 pb-20" id="urlagsport">
            <div className="container">
              <div className="row">
                <h3 className="eventsBlock__heading text-uppercase text-center">
                  Бид бүхэн жил бүр урлаг, спортын олон төрлийн үйл ажиллагааг
                  зохион байгуулдаг бөгөөд үүнд хөлбөмбөг, сагсанбөмбөг,
                  волейбол, баяр наадмын үйл ажиллагаа багтдаг билээ
                </h3>
                <Mcc />
                {UrlagSport.map((events, et) => (
                  <div className="col-lg-12 mb-10" key={et}>
                    <div className="innerWrapper">
                      <div className="donationDetails storiesDetails">
                        <div className="donationDetails__header mb-10">
                          <figure className="thumb mb-45">
                            <Slider {...urlagSportSlideSettings}>
                              <img src={events.eImg} alt="mongolsuvd" />
                              <img src={events.eImg2} alt="mongolsuvd" />
                              {events.eImg3 ? (
                                <img src={events.eImg3} alt="mongolsuvd" />
                              ) : null}
                            </Slider>
                          </figure>
                          <div className="d-flex justify-content-between">
                            <h3 className="eventsBlock__heading text-uppercase">
                              {events.title}
                            </h3>
                            <span className="eventsBlock__meta__text">
                              {events.time}
                            </span>
                          </div>
                        </div>
                        {events.slug ? (
                          <div className="eventsBlock__meta">
                            <ul>
                              <li>
                                <span className="eventsBlock__meta__title">
                                  {events.slug}
                                </span>
                              </li>
                              {events.description ? (
                                <li>
                                  <span className="eventsBlock__meta__title">
                                    {events.description}
                                  </span>
                                </li>
                              ) : null}
                            </ul>
                          </div>
                        ) : null}
                        {/* {events.description ? (
                        <p className="donationDetails__text storiesDetails__text storiesDetails__text--first mb-30">
                          {events.description}
                        </p>
                        ) : null} */}
                        {/* <h4 className="donationDetails__heading mb-25">
                        Family History Event Details
                      </h4>
                      <p className="donationDetails__text mb-30">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Curabitur vulputate vestibulum Phasellus rhoncus, dolor
                        eget viverra pretium, dolor tellus aliquet nunc, vitae
                        ultricies erat elit eu lacus. Vestibulum non justo
                        consectetur, cursus ante, tincidunt sapien. Nulla quis
                        diam sit amet turpis interdum accumsan quis nec enim.
                        Vivamus faucibus ex sed nibh egestas elementum. Mauris
                        et bibendum dui. Aenean consequat pulvinar luctus
                      </p> */}
                      </div>
                    </div>
                  </div>
                )).reverse()}
                {/* <div className="row g-4">
                  <div className="col-lg-8">
                    <div className="eventAddress">
                      <ul>
                        <li>
                          <h3 className="eventAddress__heading">Event Date</h3>
                          <span>Feb 10, 2022 @ 8:00</span>
                          <span>am - Feb 11, 2022 @</span>
                          <span>5:00 pm</span>
                        </li>
                        <li>
                          <h3 className="eventAddress__heading">
                            Event Location
                          </h3>
                          <span>Feb 10, 2022 @ 8:00</span>
                          <span>am - Feb 11, 2022 @</span>
                          <span>5:00 pm</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <figure className="thumb mb-35">
                      <img src={esImg2} alt="mongolsuvd" />
                    </figure>
                  </div>
                </div> */}
                <Mcc />
              </div>
            </div>
          </section>
        </main>
        <Footer isDark={isDark} onToggleDark={onToggleDark} />
        <Scrollbar />
      </motion.div>
    </Fragment>
  );
};
export default UrlagSportPage;
